export default __webpack_public_path__ + "assets/34958e526f8b2349fcc9039e69b456dd.jpg";